import { useSignal } from "@preact/signals";
import { useCallback } from "preact/hooks";
import { useCart } from "apps/vtex/hooks/useCart.ts";
import { sendEvent } from "$store/sdk/analytics.tsx";
import { toAnalytics } from "$store/sdk/ga4/transform/toAnalytics.ts";
import type { ToAddToCart } from "$store/sdk/ga4/events/add_to_cart.ts";

export interface Options {
  skuId: string;
  sellerId?: string;
  price: number;
  discount: number;
  name: string;
  productGroupId: string;
  quantity?: number;
  analytics?: ToAddToCart;
}

let minicartDrawer: HTMLInputElement | null;

export const useAddToCart = (
  { skuId, sellerId, price, quantity = 1, analytics }: Options,
) => {
  const isAddingToCart = useSignal(false);
  const { addItems } = useCart();

  const onClick = useCallback(async (e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    if (!sellerId) {
      return;
    }

    try {
      isAddingToCart.value = true;

      await addItems({
        orderItems: [{ id: skuId, seller: sellerId, quantity, price }],
      });

      if (analytics) {
        const add_to_cart = toAnalytics({
          type: "add_to_cart",
          data: analytics,
        });

        sendEvent(add_to_cart);
      }

      if (!minicartDrawer) {
        minicartDrawer = document.querySelector("#minicart-drawer");
      }

      if (minicartDrawer) minicartDrawer.checked = true;
    } finally {
      isAddingToCart.value = false;
    }
  }, [skuId, sellerId, quantity]);

  return { onClick, loading: isAddingToCart.value };
};
